import React from 'react';
import { Box, Button, TextField, Typography, Modal } from '@mui/material';
import { style } from '../styles';

/**
 * TestingDownloadModal Component
 * Renders the download modal with file upload interface
 *
 * @param {boolean} open - Whether the modal is open
 * @param {Function} onClose - Callback to close the modal
 * @param {Function} onDownload - Callback to handle download
 * @param {Function} onFileSelect - Callback when file is selected
 * @param {File} selectedFile - The currently selected file
 * @param {string} errorMessage - Error message to display
 */
const TestingDownloadModal = ({
  open,
  onClose,
  onDownload,
  onFileSelect,
  errorMessage
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        style={{ width: '50%', height: '95%', overflowX: 'scroll' }}
      >
        <Box
          style={{
            marginBottom: '25px',
            display: 'flex',
            gap: '20px',
            flexDirection: 'column'
          }}
        >
          <Typography
            fullWidth
            id="modal-modal-title"
            variant="h5"
            component="h2"
            style={{ marginBottom: '10px' }}
          >
            Download Template
          </Typography>
          {errorMessage && (
            <Typography
              variant="h5"
              color="red"
            >{`Error: ${errorMessage}`}</Typography>
          )}
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            marginBottom: '40px'
          }}
        >
          <Typography variant="h5">Upload Template</Typography>
          <TextField
            type="file"
            name="file"
            label="Upload Master"
            onChange={(e) => onFileSelect(e.target.files[0])}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '30px'
          }}
        >
          <Button color="error" variant="contained" onClick={onClose}>
            Close
          </Button>
          <Button variant="contained" onClick={onDownload}>
            Download
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TestingDownloadModal;
